var _circle, _circle2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnsIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "rotate(-90 20 20)",
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "rotate(-90 20 20)",
    fill: "url(#paint0_linear_193_122)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6326 22.8632L17.2687 27.8888C17.7894 27.8888 18.0149 27.6692 18.2853 27.4055L20.7264 25.115L25.7847 28.7519C26.7124 29.2595 27.366 28.9922 27.6163 27.914L30.9365 12.6393L30.9374 12.6384C31.2317 11.292 30.4415 10.7655 29.5377 11.0958L10.0214 18.4316C8.68941 18.9392 8.70957 19.6682 9.79493 19.9985L14.7845 21.5222L26.3742 14.4023C26.9196 14.0477 27.4155 14.2439 27.0076 14.5985L17.6326 22.8632Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_122",
    x1: 0,
    y1: 0,
    x2: 42.8314,
    y2: 3.30489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsIcon1);
export default __webpack_public_path__ + "static/media/sns_icon1.b4fd1678127d751623c851bf7f42d3c4.svg";
export { ForwardRef as ReactComponent };